import { gql } from '@apollo/client';

export const GetOrganizationAdministrators = gql`
  query GetOrganizationAdministrators($organizationCode: String!) {
    organizationAdministrators(organizationCode: $organizationCode) {
      firstName
      lastName
      email
    }
  }
`;
